import React, { createRef, Fragment } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import {
  Button,
  Column,
  Dialog,
  DropMenu,
  DropMenuTrigger,
  OverlayTrigger,
  PopOver,
  Portal,
  Select,
  Table,
  message,
  SelectTree,
} from '@tencent/spaui';
import { ListView } from '@tencent/ptp-fe-common';
import SpauiColumns from '@tencent/spaui-columns';
import { Tags } from '../../../consts/Tags';
import { judgeIsFromTMC, isXunda } from '../../../utils';
import { RPCFactory } from '../../../utils/RequestUtil';
import Mask from '../../common/Mask';
import LeadsDetailComponent from '../LeadsDetailComponent';
import CallConfirmDialog from '../../common/call/CallConfirmDialog';
import { DateUtil } from '../../../utils/DateUtil';
import { Common } from '../../../consts/Common';
import CustomerType from '../../../consts/CustomerType';
import PrivilegeCode from '../../../consts/PrivilegeCode';
import LeadsEditableFieldType from '../../../consts/LeadsEditableFieldType';
import LeadsOrderType from '../../../consts/LeadsOrderType';
import useCustomColumn from '../../hooks/useCustomFilter';

import { getCellsConfig } from '../../../consts/cellConfig';
import { getCellsConfigMap } from '../../../consts/cellConfigMap';
import { leadsScoreTips } from '../../../consts/Tips';
import { LeadsUploadDialog } from '../../common/LeadsUploadDialog';
import { ENABLE_BATCH_TAG_UPDATE, showTagEditor, leadsCommonFuncAndConfig, leadsObtainErrorDict } from './leadsCommonFuncAndConfig';
import { withXundaData } from '../../../cacheAPIData/WithXundaData';
import { SelectionItemComponent, ValueAreaComponent } from '../qwCustomerList/ownerPicker';
import BatchDistribute from './BatchDistribute';
import { isLeadsRole, hasPrivilege } from '../../../utils/routes';
import { beaconInstance } from '../../../instrumentation/beaconSetup';
import './style/LeadsPoolPage.css'
const mapStateToProps = (state) => ({ ...state.leadsManage, industryState: state.global });

const required = ['name', 'tel', 'leadsFollowTagName', 'leadsOpt'];
const unmovableCells = ['name', 'tel', 'leadsFollowTagName', 'leadsOpt'];

const RECYCLE_METHOD = [
  {
    label: '新增',
    value: 0,
  },
  {
    label: '回收',
    value: 1,
  },
  {
    label: '释放',
    value: 2,
  },
];

class LeadsManagePage extends React.Component {
  componentWillReceiveProps(nextProps) {
    // 这一坨不知道干啥的，保留不动
    // 更新单条leads信息
    if (
        this.props.updateType !== nextProps.updateType ||
        this.props.targetValue !== nextProps.targetValue ||
        this.props.targetLeadsId !== nextProps.targetLeadsId
    ) {
      const { data } = this.state;
      data.forEach((leadsAggragation) => {
        if (leadsAggragation.leadsId == nextProps.targetLeadsId) {
          switch (nextProps.updateType) {
            case LeadsEditableFieldType.NAME:
              leadsAggragation.name = nextProps.targetValue;
              break;
            case LeadsEditableFieldType.MEMO:
              leadsAggragation.memo = nextProps.targetValue;
              break;
            case LeadsEditableFieldType.AREA:
              leadsAggragation.area = nextProps.targetValue;
              break;
            case LeadsEditableFieldType.TEL:
              leadsAggragation.tel = nextProps.targetValue;
              break;
            case LeadsEditableFieldType.INTENTION:
              leadsAggragation.leadsIntentionScoreTag = nextProps.targetValue;
              leadsAggragation.intentionScoreTagName = Tags.leadsIntentionTag[nextProps.targetValue];
              break;
            case LeadsEditableFieldType.FOLLOW:
              leadsAggragation.allFollowRecords = nextProps.targetValue;
              break;
            case LeadsEditableFieldType.BUNDLE:
              leadsAggragation.bundle = nextProps.targetValue;
              break;
            case LeadsEditableFieldType.ownerName:
              leadsAggragation.ownerName = nextProps.targetValue;
              break;
            case LeadsEditableFieldType.CUSTOMIZED_ATTRIBUTE:
              leadsAggragation.customizedAttributes = nextProps.targetValue;
              break;
            default:
              return;
          }
          leadsAggragation.lastUpadteTime = DateUtil.getNowTimeStr();
          this.setState({ data });
          return;
        }
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const isLeadsManage = window.location.href && !window.location.href.includes('testdatas');
    if (prevState.isInFormalLeadsPage !== isLeadsManage) {
      this.setState({ isInFormalLeadsPage: isLeadsManage });
    }
  }
  componentDidMount() {
    this.checkIsInCarScoreWhiteList();
    this.query = _.get(this, 'lvObj.current.loadList', () => {
      console.log('load listview ref failed');
    });
    RPCFactory.leadsManage.getUniqueStatus().done((data) => {
      this.setState({ hideRepeatRegisterLeads: !!data });
    });
    RPCFactory.employeeManage.getEmployees(undefined, undefined, undefined, undefined, undefined)
    .done((data) => {
      const leadsOwner = [];
      (data.entities || []).forEach((employee) => {
        // var mark = employee.status == EmployeeFrozenStatus.NORMAL ? "有效" : "封停";
        let active = true;
        if (employee.status !== 0) active = false;
        if (employee.leadsReceiveStatus === 0) active = false;
        leadsOwner.push({ active, value: employee.userId, label: employee.name });
      });
      this.setState({ leadsOwners: leadsOwner });
    });
    // 查询是否支持"智能排序"
    RPCFactory.leadsOrder
    .canUseSmartOrder()
    .done((data) => {
      let { canUseSmartOrder } = data;
      canUseSmartOrder = canUseSmartOrder || false;
      this.setState({ canUseSmartOrder });
    })
    .fail((ret, msg) => {
      console.error(`Request for canUseSmartOrder error: ${msg}`);
    });

    // 获取所有企业下的所有员工
    RPCFactory.qwCustomer
    .getAllEmployes()
    .done((data) => {
      const allEmployees = (data.entities || [])
      .map(item => ({
        value: item.wxWorkUserId,
        label: item.wxWorkUserId,
      }));
      this.setState({ allEmployees });
    })
    .fail((ret, msg) => {
      console.error(`Request for get all employees error: ${msg}`);
    });

    // 获取默认展示列
    this.setColumnArr();
    this.getCustomizedAttributes();
    this.getTagGroups();

    // 获取上传、下载按钮
    this.setUploadBtnList();
    this.setDownloadBtnList();

    // 如果是TMC环境，则查询 TMC 配置
    if (judgeIsFromTMC()) {
      this.queryTMCConfig();
    }
  }
  getTagGroups = () => {
    RPCFactory.labelGroupManage
    .getGroups({ withChildren: true })
    .done((data) => {
      this.transformTagGroups(data.entities);
    })
    .fail((ret, msg) => { });
  };

  transformTagGroups = (tagGroupEntities) => {
    const tagGroups = _.filter(tagGroupEntities, 'tagCount');
    const tags = tagGroups.map((tagGroupItem) => {
      return {
        value: tagGroupItem.tagGroupId,
        desc: tagGroupItem.tagGroupName,
        options: tagGroupItem.tagList.map((tagItem) => {
          return {
            value: tagItem.tagId,
            desc: tagItem.tagName,
          };
        }),
      };
    });
    this.setState({ tagGroups: tags });
  };
  /**
   * @description 获取自定义属性
   */
  getCustomizedAttributes = () => {
    RPCFactory.accountSettings
    .getCustomizedAttributes()
    .done((data) => {
      const { customizedAttributes = [] } = data;
      this.setState({
        customizedAttributes,
      });
    })
    .fail((ret, msg) => { });
  };
  setColumnArr = (columnValueName) => {
    RPCFactory.accountSettings
    .getCustomRules()
    .done((data) => {
      const arr = [
        {
          name: 'user',
          title: '',
          list: [],
        },
      ];
      data.forEach((item) => {
        const { settingName, fieldNames = [], customizedAttributeNames = [] } = item;
        arr[0].list.push({
          label: settingName,
          value: settingName,
          keys: [...fieldNames, ...customizedAttributeNames],
        });
      });
      const localColumnConfig = this.getLocalColumnConfig(data);
      const columnValue = this.getLocalColumnConfigName();
      this.setState({ customerColumnsData: arr, selected: localColumnConfig, columnValue: { user: columnValueName || columnValue } });
    })
    .fail((ret, msg) => { });
  };

  handleUpdateLeadsTags = (leadsIds) => (tags) => {
    if (!this.lvObj.current) return;
    if (!Array.isArray(leadsIds)) throw new Error('leadsIds needs to be an array.');
    const idSet = new Set(leadsIds);
    const data = JSON.parse(JSON.stringify(this.lvObj.current.tableData));
    for (const lead of data.list) {
      if (!idSet.has(lead.leadsId)) continue;
      const _tags = lead.tags.filter((tag) => !tag.customizedTagGroup);
      lead.tags = _tags.concat(tags);
      idSet.delete(lead.leadsId);
    }
    this.lvObj.current.setTableData(data);
  };

  handleEditLeadsTags(leads) {
    const refreshListData = this.handleUpdateLeadsTags([leads.leadsId]);
    showTagEditor({
      leadsId: leads.leadsId,
      selected: leads.tags,
      submitFn: refreshListData,
    });
  }

  onBatchUpdateLabel() {
    const refreshListData = (tags) => {
      // 批量操作完成之后需要关闭批量操作条
      this.lvObj.current.setSelectKeys([]);
      this.lvObj.current.setBatchShow(false);
      this.handleUpdateLeadsTags(this.state.tableColumnChecks)(tags);
    };
    showTagEditor({
      isBatch: true,
      leadsIds: this.state.tableColumnChecks,
      // 批量修改的时候显示不选中任何标签
      selected: [],
      submitFn: refreshListData,
    });
  }

  initQuery = {
    startActionDate: {
      start_time: moment().subtract(6, 'day').format('YYYY-MM-DD'),
      end_time: moment().format('YYYY-MM-DD'),
    },
  };

  state = {};

  constructor(props) {
    super(props);
    this.lvObj = createRef();
    const nowDateStr = DateUtil.getTodayDateStr();
    const weekAgoDateStr = DateUtil.getWeekAgoDateStr();
    this.state = {
      /**
       *  搜索区
       */
      pageSize: 10,
      pageIndex: 1,
      showUpdateOperationDialog: false,
      showCallConfirmDialog: false,
      startActionDate: weekAgoDateStr,
      endActionDate: nowDateStr,
      ownerIds: [],
      searchOwnerValue: '',
      leadsOwners: [],
      orderType: LeadsOrderType.DEFAULT.getId(),
      // 落地页id搜索select
      pageSelect: {},
      followTags: [],
      // 联系人信息搜索group
      searchGroup: {},

      // 表格
      tableColumnChecks: [],
      data: [],

      // 表格自定义头
      barchBarDisplayValue: 'none',

      // 详情portal
      leadsDetailPortalTarget: '',
      detailLeadsId: '',

      // 表格编辑
      followTagDialog: { show: false },
      leadsScoreDialog: { show: false, disable: false },

      isShowMultiMark: false,
      isShowLeadsImport: false,
      hideRepeatRegisterLeads: false,
      // 是否在线索公海池页
      isInFormalLeadsPage: window.location.href && !window.location.href.includes('testdatas'),
      isShowSOPLeadsImport: false,
      // 自定义列
      columnShow: false,
      fixed: [],
      selected: leadsCommonFuncAndConfig.defaultSelectedColumns,
      modalSelected: [],
      columnChecked: true,
      columnDisabled: false,
      columnInputValue: '',
      actionSubTypes: [],
      columnValue: '',
      customerColumnsData: [],
      settingOldName: '',
      columnStatus: '',

      // 自定义属性
      customizedAttributes: [],
      tagGroups: [],

      // 上传按钮列表
      uploadBtnList: [],
      uploadBtnValue: '',

      // 下载按钮列表
      downloadBtnList: [],
      downloadBtnValue: '',

      helpBlock: '',
      canUseSmartOrder: false,
      scoreTag: leadsScoreTips.intentionScoreTag,

      // 所有企业下的所有员工
      allEmployees: [],

      showBatchDistribute: false,
      showReasonsDialog: false, // 是否展示认领失败弹窗
      // TMC 配置
      tmcConfig: null,
      // 线索认领
      isService: isLeadsRole('客服人员', '客服经理') && hasPrivilege('CLAIM_LEADS'),
      claiming: false,
      claimConfirming: false,
      pageKey: `${this.props.location.pathname}-${window.pageProps.operationUserId}`,
    };
    this.TipComponent = leadsCommonFuncAndConfig.getTipComponent(this);
    this.canDownload = !isLeadsRole('客服人员') && !this.state.isService;

    const query = new URLSearchParams(this.props.location.search);
    const insertDefaultQueryValue = (key) => {
      if (!query.has(key)) return;
      this.initQuery[key] = query.get(key);
    };
    ['componentId', 'pageId'].forEach(insertDefaultQueryValue);

    // 处理 MP 跳转过来携带的查询参数
    (() => {
      /**
       * 保证时间筛选区间以开始时间为准不超过一年
       */
      const validateEndTime = () => {
        const initStartDay = this.initQuery.startActionDate.start_time;
        const initEndDay = this.initQuery.startActionDate.end_time;
        const finalEndDay = moment(initStartDay).add(365, 'day');
        if (finalEndDay.valueOf() < moment(initEndDay).valueOf()) {
          this.initQuery.startActionDate.end_time = finalEndDay.format('YYYY-MM-DD');
        }
      };
      const urlQuery = new URLSearchParams(window.location.search);
      if (urlQuery.has('campaignId')) {
        this.initQuery.campaignId = urlQuery.get('campaignId');
      }
      if (urlQuery.has('startTime')) {
        const startTime = urlQuery.get('startTime');
        if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(startTime)) {
          this.initQuery.startActionDate.start_time = startTime;
          validateEndTime();
        }
      }
    })();

    // 处理TMS跳转携带过来的查询参数
    (() => {
      const urlQuery = new URLSearchParams(window.location.search);
      if (urlQuery.has('pageId')) {
        this.initQuery.pageId = urlQuery.get('pageId');
      } else if (urlQuery.has('followTags')) {
        this.initQuery.followTags = urlQuery.get('followTags').split(',');
      }
    })();
  }
  showColumn = (data, value) => {
    this.setState({
      columnShow: true,
      columnChecked: true,
      settingOldName: data.label,
      columnInputValue: data.label,
      modalSelected: data.keys,
      // selected: data.keys,
    });
  };
  selfShowColumn = () => {
    this.setState({
      columnShow: true,
      columnChecked: true,
      settingOldName: '',
      // selected: leadsCommonFuncAndConfig.defaultSelectedColumns,
      modalSelected: leadsCommonFuncAndConfig.defaultSelectedColumns,
    });
  };
  deleteColumn = (data) => {
    RPCFactory.accountSettings
    .deleteCustomRules(data.label)
    .done((data) => {
      this.setColumnArr();
    })
    .fail((ret, msg) => {
      alert(`请求失败，msg:${msg}`);
    });
  };
  columnCancel = () => {
    this.setState({
      columnShow: false,
    });
  };
  getLocalColumnConfigName = () => {
    const settingName = localStorage.getItem(this.state.pageKey);
    return settingName
  }
  getLocalColumnConfig = (customRules) => {
    const settingName = this.getLocalColumnConfigName();
    const config = customRules.find(item => item.settingName === settingName) || {}
    return config.fieldNames || leadsCommonFuncAndConfig.defaultSelectedColumns;
  }

  setLocalColumnConfigName = (name) => {
    localStorage.setItem(this.state.pageKey, name);
  }
  columnSubmit = (state) => {
    const { columnInputValue } = this.state;
    if (
        !!this.state.columnChecked &&
        this.state.settingOldName == '' &&
        this.state.customerColumnsData[0].list &&
        this.state.customerColumnsData[0].list.length > 9
    ) {
      alert('设置已达上限，如需继续添加请先删除');
      return;
    }
    if (this.state.columnChecked && this.state.columnInputValue.replace(/(^s*)|(s*$)/g, '').length == 0) {
      window.alert('自定义名称不能为空');
      return;
    }
    this.setState(state);

    const { selected } = state;
    const rules = selected;
    // const rules = _.filter(selected, (v) => _.find(this.state.customizedAttributes, (x) => x.name !== v));
    const customizedAttributeNames = _.filter(selected, (v) =>
        _.find(this.state.customizedAttributes, (x) => x.name === v),
    );
    if (this.state.columnChecked && this.state.settingOldName == '') {
      RPCFactory.accountSettings
      .setCustomRules(rules, this.state.columnInputValue, customizedAttributeNames)
      .done((data) => {
        this.setLocalColumnConfigName(columnInputValue);
        this.setColumnArr(columnInputValue);
      })
      .fail((ret, msg) => {
        alert(`请求失败，msg:${msg}`);
      });
    } else if (this.state.columnChecked && this.state.settingOldName != '') {
      RPCFactory.accountSettings
      .updateCustomRules(rules, this.state.columnInputValue, this.state.settingOldName, customizedAttributeNames)
      .done((data) => {
        this.setLocalColumnConfigName(columnInputValue);
        this.setColumnArr(columnInputValue);
      })
      .fail((ret, msg) => {
        alert(`请求失败，msg:${msg}`);
      });
    }
    this.setState({
      columnShow: false,
      columnChecked: false,
      columnInputValue: '',
    });
  };
  columnChange = (e, value, props) => {
    if (
        this.state.settingOldName == '' &&
        this.state.customerColumnsData[0].list &&
        this.state.customerColumnsData[0].list.length > 9
    ) {
      alert('设置已达上限，如需继续添加请先删除');
      return;
    }
    const len = this.state.columnInputValue.length || 0;
    if (len < 1) {
      this.setState({
        columnStatus: 'error',
        helpBlock: '请输入名称',
      });
    }
    this.setState({
      columnChecked: value,
      selected: props.currentState.selected,
    });
  };

  columnHandleChange = (event, value, itemValue) => {
    this.setState({
      columnValue: value,
      selected: itemValue.keys,
    });
    this.setLocalColumnConfigName(itemValue.label);
  };
  resetColums = () => {
    this.setState({
      columnValue: '',
      selected: leadsCommonFuncAndConfig.defaultSelectedColumns,
    });
    this.setLocalColumnConfigName('');
  }
  columnHandleInputChange = (event, value, props) => {
    const len = value.length || 0;
    let helpBlock = '';
    let status = '';

    if (len < 1) {
      status = 'error';
      helpBlock = '请输入名称';
    } else if (len > 30) {
      status = 'error';
      helpBlock = '名称不能超过30个字';
    } else {
      status = '';
      helpBlock = '';
    }
    this.setState({
      columnInputValue: value,
      columnStatus: status,
      helpBlock,
      modalSelected: props.currentState.selected,
    });
  };
  /**
   * =====================================================================
   * barchBar部分
   */
  showBarchBar = () => {
    this.setState({ barchBarDisplayValue: '' });
  };

  hideBarchBar = () => {
    this.setState({ barchBarDisplayValue: 'none' });
  };

  onChangeBarchBarCheck = (event, value) => {
    if (value) {
      const tableColumnChecks = [];
      this.state.data.forEach((leadsVo) => {
        tableColumnChecks.push(leadsVo.leadsId);
      });
      this.setState({ tableColumnChecks });
    } else {
      this.setState({ tableColumnChecks: [] });
    }
  };

  showSOPLeadsImport = () => {
    this.setState({ isShowSOPLeadsImport: true });
  };
  hideSOPLeadsImport = () => {
    this.setState({ isShowSOPLeadsImport: false });
  };

  hideDistributeOwnerDialog = (event) => {
    this.setState({ showBatchDistribute: false });
  };

  leadsBatchDistribute = (data) => {
    const params = {
      distributeType: data.method === 'custom' ? 2 : 1,
      leadsIds: data.leads || [],
      distributeItems: data.employees.map((item) => {
        const obj = {
          targetOwnerId: item.id,
          leadsCount: data.map[item.id] || 0,
        };
        if (data.method === 'custom') {
          obj.proportion = item.percent;
        }
        return obj;
      }),
    };
    return new Promise((res) => {
      RPCFactory.leadsManage.leadsBatchDistribute(params)
      .done(() => {
        setTimeout(() => {
          this.query();
          this.hideBarchBar();
          this.hideDistributeOwnerDialog();
          this.lvObj.current.loadList();
          this.lvObj.current.setSelectKeys([]);
          this.lvObj.current.setBatchShow(false);
          res();
        }, 300);
      })
      .fail((ret, msg) => {
        alert(msg);
        res();
      });
    });
  };

  onSearchOwner = (event, value) => {
    this.setState({ ownerIds: value });
  };

  /**
   * 查询
   * @param params
   */
  query = () => {
    console.log('listview ref not loaded');
  };

  /**
   * =====================================================================
   * 上传/下载相关操作 start
   */
  setUploadBtnList = () => {
    let list = [];
    if (this.state.isService) return list;
    if (this.state.isInFormalLeadsPage) {
      if (window.pageProps.privileges.includes(PrivilegeCode.DEFEAT_LEADS_IMPORT.getCode())) {
        list.push({
          label: '上传战败线索',
          value: 'SOPLeadsImport',
        });
      }
      list = [...list, {
        label: '导入线索',
        value: 'leadsImport',
      },
        {
          label: '上传标记',
          value: 'multiMark',
        },
      ];

      this.setState({
        uploadBtnList: list,
      });
    }
  }

  uploadHandleChange = (event, value) => {
    const currentValue = value.upload;
    if (currentValue === 'leadsImport') {
      this.showLeadsImport();
    } else if (currentValue === 'multiMark') {
      this.showMultiMark();
    } else if (currentValue === 'SOPLeadsImport') {
      this.showSOPLeadsImport();
    }

    this.setState({
      uploadBtnValue: value
    });
  }


  setDownloadBtnList = () => {
    const list = [{
      label: (
          <OverlayTrigger trigger="hover" placement="left" overlay={(
              <PopOver className="" style={{ width: 250 }}>
                线索下载功能升级啦！支持广告主根据自定义列设置仅选择所需字段下载线索明细，也支持批量勾选部分线索单独下载，快来体验吧！
              </PopOver>
          )}>
            <span className="spaui-text">下载线索数据</span>
          </OverlayTrigger>
      ),
      value: 'downloadLeads',
    }];

    this.setState({
      downloadBtnList: list,
    });
  }

  downloadHandleChange = (event, value) => {
    const currentValue = value.download;
    RPCFactory.checkLogin
    .advertiserPageLogin()
    .done((result) => {
      if (result && result.success) {
        if (currentValue === 'downloadLeads') {
          this.downloadLeads();
        }
      } else if (judgeIsFromTMC()) {
        top.postMessage({ type: 'freshToken' }, '*');
      } else if (result) {
        window.location = result.ssoURL;
      }
    })
    .fail((ret, msg) => {
      alert(msg);
    });

    this.setState({
      downloadBtnValue: value
    });
  }

  /**
   * =====================================================================
   * 上传/下载相关操作 end
   */

  getDownloadQueryParams = () => {
    const queryData = { ..._.get(this, 'lvObj.current.requestParams') || {} };
    delete queryData.pageIndex;
    delete queryData.pageSize;
    const queryItems = Object.keys(queryData).map(property => {
      const value = queryData[property];
      if (value === undefined) return undefined;
      let key = property;
      if (Array.isArray(value)) {
        key += 'Str';
      }
      return { key, value };
    }).filter(Boolean);
    queryItems.unshift({ key: 'accountId', value: window.pageProps.uid });
    if (this.state.curRoleType == 'group') {
      queryItems.push({
        key: 'userGroupId',
        value: window.pageProps.userGroupId
      })
    }
    const queryStr = `?${queryItems.map(item => `${item.key}=${item.value}`).join('&')}`;
    return queryStr;
  };

  /**
   * 下载
   * @param event
   */
  downloadLeads = (isBatch) => {
    isBatch = isBatch === true;
    const selectedColumns = (this.showColumns || []).filter(Boolean).map((item) => item.name);
    const selectLeads = this.state.tableColumnChecks || [];
    const query = new URLSearchParams(this.getDownloadQueryParams());
    const addArrParams = ([key, arr]) => {
      if (!Array.isArray(arr) || arr.length < 1) return;
      query.set(key, arr.join(','));
    };
    [
      ['customizedColumns', selectedColumns],
      isBatch && ['leadsIds', selectLeads],
    ].filter(Boolean).forEach(addArrParams);
    const queryParam = `?${query.toString()}`;

    if (window.pageProps.adUserType == CustomerType.DIRECT.getId() && window.pageProps.appId) {
      window.location.href = Common.ASSOCIATE_DOWNLOAD + queryParam;
    } else {
      window.location.href = Common.LEADS_DOWNLOAD + queryParam;
    }
  };

  renderSex = (type, name, value, data) => {
    if (type != 'head') {
      const Sex = { 2: '男', 1: '女' };
      return Sex[value] ? Sex[value] : '--';
    }
    return value;
  };

  // 详情关闭时，回调
  onDetailShutdown = () => {
    Mask.hide();
    this.setState({ leadsDetailPortalTarget: '' });
    this.lvObj.current.loadList();
  };

  // 点击线索时，查看详情
  showDetail = (e, leadsId, name, location) => {
    Mask.show();
    this.setState({
      leadsDetailPortalTarget: document.getElementById('leadsDetail'),
      detailLeadsId: leadsId,
      detailLeadsName: name,
      detailLeadsLocation: location,
    });
  };

  /**
   * =====================================================================
   * 表格区部分
   */
  /**
   * render
   * @param type
   * @param name
   * @param value
   * @param data
   * @returns {*}
   */
  renderLeadsId = (type, name, value, data) => {
    if (type != 'head') {
      // 6个字符截断
      let text = '';
      if (value && value.length >= 6) {
        text = `${value.substr(0, 6)}...`;
      } else {
        text = value;
      }

      let nameLabel = text ? text : '未命名';

      const canShowDetail = window.pageProps.privileges.includes(PrivilegeCode.LEADS_PUBLIC_POOL_VIEW_DETAIL.getCode());

      if (canShowDetail) {
        nameLabel = (
            <a style={{ cursor: 'pointer' }} onClick={(e) => this.showDetail(e, data.leadsId, data.name, data.telLocation)}>
              {text ? text : '未命名'}
            </a>
        );
      }
      return (
          <div title={value}>
            {nameLabel}
            <div style={{ display: 'none' }}>{data.leadsId}</div>
          </div>
      );
    }
    return value;
  };

  renderTel = (type, name, value, data) => {
    if (!value) {
      return;
    }

    if (type === 'head') {
      return <div style={{ paddingLeft: 22 }}>{value}</div>;
    }

    if (this.state.isService) return value;

    let call;
    const canCall =
        window.pageProps.operatorRole != 'OPERATOR_ROLE_LEADS_AGENCY' &&
        window.pageProps.operatorRole != 'OPERATOR_ROLE_LEADS_ADOPERATOR';
    if (canCall) {
      call = (
          <a
              style={{ cursor: 'pointer' }}
              className="call-num"
              onClick={(event) => this.showCallDialog(event, value, data.leadsId, data.name, data.telLocation, data.tags)}
          >
            <i className="icon-phone" style={{ marginLeft: 4 }} />
            {value}
          </a>
      );
    } else {
      call = value;
    }
    return <div className="phone-number">{call}</div>;
  };

  followTagDialog = {
    show: (target, value, leadsId) => {
      const { followTagDialog } = this.state;
      followTagDialog.eventTarget = target;
      followTagDialog.eventTargetLeft = target.getBoundingClientRect().left;
      followTagDialog.eventTargetTop = target.getBoundingClientRect().top;
      followTagDialog.show = true;
      followTagDialog.leadsId = leadsId;
      followTagDialog.leadsFollowTag = value;
      this.setState({ followTagDialog });
    },
    onClose: () => {
      const { followTagDialog } = this.state;
      followTagDialog.show = false;
      this.setState({ followTagDialog });
    },
    onChange: (event, value) => {
      const { followTagDialog } = this.state;
      followTagDialog.leadsFollowTag = value;
      this.setState({ followTagDialog });
    },
    onConfirm: () => {
      const { followTagDialog } = this.state;
      const selected = _.get(this, 'lvObj.current.selectKeys', []);
      if (!followTagDialog.leadsFollowTag) {
        this.setState({
          followTagDialog: {
            ...this.state.followTagDialog,
            disable: false,
          },
        });
        return alert('请选择线索状态');
      }
      if (selected.length < 1) {
        followTagDialog.disable = false;
        return alert('请选择需要修改的线索');
      }
      RPCFactory.leadsManage
      .updateLeadsFollowTags(selected, followTagDialog.leadsFollowTag)
      .done((data) => {
        followTagDialog.disable = false;
        this.setState({ followTagDialog });
        this.followTagDialog.onClose();
        this.lvObj.current.loadList();
        this.lvObj.current.setSelectKeys([]);
        this.lvObj.current.setBatchShow(false);
      })
      .fail((status, msg) => {
        alert(`请求失败，msg:${msg}`);
        followTagDialog.disable = false;
        this.setState({ followTagDialog });
      });
    },
  };

  checkIsInCarScoreWhiteList = () => {
    RPCFactory.account.check_whitelist(window.pageProps.uid, 'auto.intention.score.whiteList').done((data) => {
      if (data) {
        this.setState({ scoreTag: leadsScoreTips.carScoreTag });
      }
    });
  };

  queryTMCConfig = () => {
    RPCFactory.leadsManage
    .getTmcConfig()
    .done((data) => {
      this.setState({ tmcConfig: data });
    })
    .fail((ret, msg) => {
      window.alert(`查询TMC配置失败, ${msg}`);
    });
  };

  renderIntentionScoreTagName = (type, name, value, data) => {
    const popoverstyle = {
      maxWidth: '800px',
    };

    const { scoreTag } = this.state;
    const popover = (
        <PopOver style={popoverstyle}>
          <div className="poptable">
            <Table hideThead={true} data={scoreTag}>
              <Column name="enumValue" minWidth={200}>
                枚举值
              </Column>
              <Column name="enumDetail">说明</Column>
            </Table>
          </div>
        </PopOver>
    );
    if (type == 'head') {
      return (
          <div>
            {value}
            <OverlayTrigger trigger="hover" delay={100} overlay={popover}>
              <i className="icon icon-help">
                <i></i>
              </i>
            </OverlayTrigger>
          </div>
      );
    }
    return <span>{value}</span>;
  };

  leadsScoreDialog = {
    show: (target, value, leadsId) => {
      const { leadsScoreDialog } = this.state;
      leadsScoreDialog.eventTarget = target;
      leadsScoreDialog.eventTargetLeft = target.getBoundingClientRect().left;
      leadsScoreDialog.eventTargetTop = target.getBoundingClientRect().top;
      leadsScoreDialog.show = true;
      leadsScoreDialog.leadsId = leadsId;
      leadsScoreDialog.leadsIntentionScoreTag = value;
      this.setState({ leadsScoreDialog });
    },
    onClose: () => {
      const { leadsScoreDialog } = this.state;
      leadsScoreDialog.show = false;
      this.setState({ leadsScoreDialog });
    },
    onChange: (event, value) => {
      const { leadsScoreDialog } = this.state;
      leadsScoreDialog.leadsIntentionScoreTag = value;
      this.setState({ leadsScoreDialog });
    },
    onConfirm: () => {
      const { leadsScoreDialog } = this.state;
      const selected = _.get(this, 'lvObj.current.selectKeys', []);
      if (!leadsScoreDialog.leadsIntentionScoreTag) {
        this.setState({
          leadsScoreDialog: {
            ...this.state.leadsScoreDialog,
            disable: false,
          },
        });
        return alert('请选择线索评分');
      }
      if (selected.length < 1) {
        leadsScoreDialog.disable = false;
        return alert('请选择需要分配的线索');
      }
      RPCFactory.leadsManage
      .updateLeadsIntentionTags(window.pageProps.uid, selected, leadsScoreDialog.leadsIntentionScoreTag)
      .done((data) => {
        leadsScoreDialog.disable = false;
        this.setState({ leadsScoreDialog });
        this.leadsScoreDialog.onClose();
        this.lvObj.current.loadList();
        this.lvObj.current.setSelectKeys([]);
        this.lvObj.current.setBatchShow(false);
      })
      .fail((status, msg) => {
        alert(`请求失败，msg:${msg}`);
        leadsScoreDialog.disable = false;
        this.setState({ leadsScoreDialog });
      });
    },
  };

  onTableOptionalChange = (event, value) => {
    this.setState({ tableColumnChecks: value });
    this.showBarchBar();
  };
  /**
   * 表格区部分 end
   * =====================================================================
   */

  /**
   * =====================================================================
   * 外呼部分
   */
  showCallDialog = (event, callee, leadsId, name, telLocation, tags) => {
    if (!callee) {
      alert('被叫号码不能为空');
      return;
    }
    if (judgeIsFromTMC()) {
      top.postMessage({
        type: 'showCallDialog', data: {
          showCallConfirmDialog: true,
          callee,
          calleeName: name,
          calleeArea: telLocation,
          calleeLeadsId: leadsId,
          tags,
        }
      }, '*')
    } else {
      this.setState({
        showCallConfirmDialog: true,
        callee,
        calleeName: name,
        calleeArea: telLocation,
        calleeLeadsId: leadsId,
        tags,
      });
    }

  };

  onCancelCall = (event) => {
    this.setState({ showCallConfirmDialog: false });
  };

  onSubmitCall = (event) => {
    RPCFactory.call
    .call(window.pageProps.uid, this.state.callee, this.state.calleeLeadsId)
    .done((data) => {
      this.onCancelCall({});
    })
    .fail((ret, msg) => {
      alert(msg);
    });
  };
  showMultiMark() {
    this.setState({
      isShowMultiMark: true,
    });
  }

  hideMultiMark = () => {
    this.setState({
      isShowMultiMark: false,
    });
  };

  showLeadsImport() {
    this.setState({
      isShowLeadsImport: true,
    });
  }

  goToTestList() {
    this.props.history.push('/leads/pool/leadsPool/testdatas');
  }

  hideLeadsImport = () => {
    this.setState({
      isShowLeadsImport: false,
    });
  };
  /**
   * 外呼部分end
   * =====================================================================
   */

  render() {
    const cellsConfigMap = getCellsConfigMap(this.state.customizedAttributes);
    const cellsConfig = getCellsConfig(this.state.customizedAttributes);
    const poolWay = {
      name: 'enterPoolWay',
      displayName: '入池方式',
      cellName: '入池方式',
      align: 'left',
      privilege: 'ALL',
    };
    cellsConfigMap.enterPoolWay = poolWay;
    cellsConfig.null.list[3].columns.push(poolWay);

    if (isXunda()) {
      let title = '楼盘';
      if (isXunda('车')) title = '商家';
      cellsConfigMap.leadsPoolId = {
        name: 'leadsPoolId',
        displayName: title,
        cellName: title,
        align: 'left',
        privilege: 'ALL',
      };
      cellsConfig.null.list[2].columns.push({
        name: 'leadsPoolId',
        displayName: title,
        cellName: title,
        align: 'left',
        privilege: 'ALL',
      });
    }

    return (
        <div className="main">
          <div className="page-pool">
            {
                !this.state.isInFormalLeadsPage && (
                    <leadsCommonFuncAndConfig.TestHeader
                        parentRouterText="线索公海池"
                        parentRouterPath="#/leads/pool/leadsPool"
                    />
                )
            }
            {this.state.isInFormalLeadsPage && (
                <LeadsUploadDialog
                    hideLeadsImport={this.hideMultiMark}
                    query={this.query}
                    updateLeadsImport={RPCFactory.leadsManage.updateLeadsBatchMark}
                    isShowLeadsImport={this.state.isShowMultiMark}
                    dialogTitle="上传标记线索状态"
                    actionName="标记"
                    downloadFailFileApi="/api/v1/leads/download_fail_batch_mark_convert_type"
                    leadsUploadApi="/api/v1/leads/upload_batch_mark_file"
                    uploadParaName="uploadedFile"
                    importType="old"
                    importDetail={
                      <div className="exp">
                        <p className="tt">不知道上传什么文件进行标记？</p>
                        <p className="step">第一步：在线索管理下载线索数据，获取线索ID</p>
                        <p className="step">
                          第二步：
                          <a target="_blank" href="/assets/doc/leads_status_change_template.xlsx">
                            下载文件模板
                          </a>
                          ，将线索ID信息移入文件并标记线索状态，然后在此处上传
                        </p>
                        <p className="exp-tip">
                          线索ID需与平台线索ID一致，未匹配数据或超出1000条的数据将作为无效数据处理。线索状态为：未分配、跟进中、已转换-潜在客户、已转换-高意向客户、已转换-已成单、无效-重复、无效-非本人、无效-未接通、无效-无意向、无效-定向外、无效-其他。
                        </p>
                      </div>
                    }
                />
            )}
            {this.state.isInFormalLeadsPage && (
                <LeadsUploadDialog
                    hideLeadsImport={this.hideSOPLeadsImport}
                    query={this.query}
                    updateLeadsImport={RPCFactory.leadsManage.updateLeadsImport}
                    isShowLeadsImport={this.state.isShowSOPLeadsImport}
                    dialogTitle="战败线索导入"
                    actionName="导入"
                    taskType={2}
                />
            )}
            {this.state.isInFormalLeadsPage && (
                <LeadsUploadDialog
                    hideLeadsImport={this.hideLeadsImport}
                    query={this.query}
                    updateLeadsImport={RPCFactory.leadsManage.updateLeadsImport}
                    isShowLeadsImport={this.state.isShowLeadsImport}
                    dialogTitle="线索导入"
                    actionName="导入"
                    taskType={1}
                    importWarning="腾讯线索管理平台仅支持广告主导入合法合规收集的线索，若导入非合法来源线索后使用平台外呼功能造成用户投诉，且广告主无法提供线索合法来源证明，本平台将限制该账号主体下所有账号对外部导入线索的外呼功能并追究相应责任。"
                />
            )}

            <div className="card" style={{ paddingTop: 0 }}>
              <div className="datalist">
                <ListView
                    className="lv"
                    ref={this.lvObj}
                    options={this.lvOptions}
                    payloads={this.lvPayloads}
                    customFunctions={this.lvCustomFunctions}
                />
              </div>

              <div id="leadsDetail"></div>
              {this.state.leadsDetailPortalTarget ? (
                  <Portal target={this.state.leadsDetailPortalTarget}>
                    <LeadsDetailComponent
                        showCallDialog={this.showCallDialog}
                        leadsId={this.state.detailLeadsId}
                        name={this.state.detailLeadsName}
                        location={this.state.detailLeadsLocation}
                        shutDown={this.onDetailShutdown}
                        isTestData={!this.state.isInFormalLeadsPage}
                        leadsTab="pool"
                    />
                  </Portal>
              ) : (
                  ''
              )}
              <CallConfirmDialog
                  show={this.state.showCallConfirmDialog}
                  leadsId={this.state.calleeLeadsId}
                  name={this.state.calleeName}
                  location={this.state.calleeArea}
                  callee={this.state.callee}
                  tags={this.state.tags}
                  updateTagsCallback={this.handleUpdateLeadsTags([this.state.calleeLeadsId])}
                  onCancel={this.onCancelCall}
                  onSubmit={this.onSubmitCall}
              />
            </div>

            {this.state.isInFormalLeadsPage && (
                <Dialog
                    eventTarget={this.state.followTagDialog.eventTarget}
                    style={{ width: '400px' }}
                    eventTargetLeftDeviation={-70}
                    eventTargetTopDeviation={-110}
                    show={this.state.followTagDialog.show}
                    onClose={this.followTagDialog.onClose}
                    onSubmit={(e) => {
                      const { followTagDialog } = this.state;
                      followTagDialog.disable = true;
                      this.setState({ followTagDialog }, () => {
                        this.followTagDialog.onConfirm();
                      });
                    }}
                    onCancel={this.followTagDialog.onClose}
                    title="修改线索状态"
                    className="modal-w300 modal-simple"
                    disabled={this.state.followTagDialog.disable}
                >
                  <SelectTree
                      placeholder="线索状态"
                      valueType="child"
                      data={_.get(this.props, 'industryState.currentStateTree', [])}
                      value={this.state.followTagDialog.leadsFollowTag}
                      onChange={this.followTagDialog.onChange}
                  />
                </Dialog>
            )}

            {this.state.isInFormalLeadsPage && (
                <Dialog
                    eventTarget={this.state.leadsScoreDialog.eventTarget}
                    eventTargetLeftDeviation={-70}
                    eventTargetTopDeviation={-70}
                    style={{ width: '300px' }}
                    show={this.state.leadsScoreDialog.show}
                    onClose={this.leadsScoreDialog.onClose}
                    onSubmit={(e) => {
                      const { leadsScoreDialog } = this.state;
                      leadsScoreDialog.disable = true;
                      this.setState({ leadsScoreDialog }, () => {
                        this.leadsScoreDialog.onConfirm();
                      });
                    }}
                    onCancel={this.leadsScoreDialog.onClose}
                    title="修改线索评分"
                    className="modal-w300 modal-simple"
                    disabled={this.state.leadsScoreDialog.disable}
                >
                  <Select
                      placeholder="线索评分"
                      data={leadsCommonFuncAndConfig.leadsIntentionTags}
                      value={this.state.leadsScoreDialog.leadsIntentionScoreTag}
                      onChange={this.leadsScoreDialog.onChange}
                      onClear={this.leadsScoreDialog.onClear}
                  />
                </Dialog>
            )}
            <SpauiColumns
                show={this.state.columnShow}
                hideHeader={true}
                onCancel={this.columnCancel}
                onSubmit={this.columnSubmit}
                unmovableCells={unmovableCells}
                required={required}
                fixed={this.state.fixed}
                selected={this.state.modalSelected}
                cellsConfig={cellsConfig}
                cellsConfigMap={cellsConfigMap}
                columnInputValue={this.state.columnInputValue}
                columnHandleInputChange={this.columnHandleInputChange}
                dialogProps={{
                  hideHeader: true,
                }}
                TipComponent={this.TipComponent}
            />
          </div>
          <BatchDistribute
              leads={this.state.tableColumnChecks || []}
              show={this.state.showBatchDistribute}
              onSubmit={this.leadsBatchDistribute}
              onClose={this.hideDistributeOwnerDialog}
              onCancel={this.hideDistributeOwnerDialog}
              ownerList={this.state.leadsOwners}
          />
          {/* 认领失败弹窗 by fighting*/}
          <Dialog
              show={this.state.showReasonsDialog}
              type="normal"
              className="spaui-dialog-confirm-normal"
              title='线索认领失败'
              backdrop
              closeButton={false}
              cancelButton={false}
              onSubmit={() => {this.setState({ showReasonsDialog: false })}}
          >
            <div className="reason-tip-dialog">
              <div className="content">
                <div className="content-wrapper">
                  {_.map(this.state.obtainReasons, ({ reason, leadsIds }) => (
                      <div>
                        <div className="items-title">{reason}</div>
                        <div className="items-text"  style={{ marginBottom: '5px' }}>{leadsIds}</div>
                      </div>
                  ))}
                </div>
              </div>
            </div>
          </Dialog>
        </div>
    );
  }

  /**
   * ListView 需要的数据
   * TODO showColumns 的逻辑
   */

  getList = (params) =>
      new Promise((res, rej) => {
        this.setState({ showLoading: true });
        RPCFactory.leadsManage
        .getLeadsModelViewInfo(window.pageProps.uid, params, window.pageProps.appId, window.pageProps.adUserType)
        .done((data) => {
          this.setState({
            data: data.entities,
            totalSize: data.size,
          });
          this.setState({ showLoading: false });
          const leadsData = {
            list: [],
            page_info: {
              total_number: 0,
            },
          };
          leadsData.list = data.entities;
          leadsData.page_info.total_number = data.size;
          res(leadsData);
        })
        .fail((ret, msg) => {
          this.setState({ showLoading: false });
          rej(msg);
        });
      });

  getAllFilterConfig = () => {
    this.filterControls = leadsCommonFuncAndConfig.getFilterControl();
    this.filterControls.splice(1, 0, {
      name: 'ownerIds',
      title: '归属人',
      type: 'select',
      config: {
        multiple: true,
        data: this.state.leadsOwners,
      },
    });
    this.filterControls.splice(2, 0, {
      name: 'leadsTags',
      title: '线索标签',
      type: 'select-tree',
      config: {
        multiple: true,
        data: this.state.tagGroups,
        showParentNodeLabel: false,
        valueType: 'child',
      },
    });
    this.filterControls.push({
      name: 'matchedWxWorkUserId',
      title: '企微客户归属人',
      type: 'select',
      config: {
        data: this.state.allEmployees,
        SelectionItemComponent,
        ValueAreaComponent,
      },
    });
    this.filterControls.push({
      name: 'enterPoolWays',
      title: '入池方式',
      type: 'select',
      config: {
        data: RECYCLE_METHOD,
      },
    });
    if (!window.pageProps.appId) {
      this.filterControls.splice(9, 0, {
        name: 'componentId',
        title: '组件ID',
        type: 'search',
        rules: [{ pattern: /^\d*$/, message: '请输入组件ID' }],
      });
    }
    // 自定义筛选项配置
    const defaultFilterKeys = [
      'startActionDate',
      'ownerIds',
      // 'leadsTags',
      'leadsCallCleaningTags',
      'actionSubTypes',
      'leadsSources',
      'leadsTouchTags',
      'intentionTags',
    ];

    if (this.state.isInFormalLeadsPage) {
      defaultFilterKeys.splice(3, 0, 'leadsTags');
    }
    if (this.state.canUseSmartOrder) {
      this.filterControls.push({
        name: 'orderType',
        title: '排序方式',
        type: 'select',
        config: {
          data: Object.keys(LeadsOrderType).map((key) => ({
            value: LeadsOrderType[key].getId(),
            label: LeadsOrderType[key].getDesc(),
          })),
        },
      });
      defaultFilterKeys.push('orderType');
    }
    if (window.pageProps.isInnerAccount) {
      this.filterControls.push({
        name: 'lgMethods',
        title: '请选择LG处理方式',
        type: 'select',
        config: {
          multiple: true,
          data: Object.keys(Tags.lgMethodTags).map((key) => ({
            label: Tags.lgMethodTags[key],
            value: key,
          })),
        },
      });
      defaultFilterKeys.push('lgMethods');
    }
    if (isXunda()) {
      let title = '楼盘名称';
      if (isXunda('车')) title = '商家名称';
      this.filterControls.push({
        title,
        type: 'select',
        name: 'leadsPoolId',
        config: {
          multiple: false,
          theNumberOfDisplay: 100,
          data: this.props.xundaData.pools.map((item) => ({
            value: item.leads_pool_id,
            label: item.name,
          })),
        },
      });
    }
    const query = new URLSearchParams(this.props.location.search);
    const insertDefaultFilterKeys = (key) => {
      if (!query.has(key)) return;
      defaultFilterKeys.push(key);
    };
    ['componentId', 'pageId'].forEach(insertDefaultFilterKeys);
    this.customFilterConfigure = useCustomColumn({
      defaultFilterKeys,
      controls: this.filterControls,
      storageKey: 'ams:user_profile:advertiser_custom_filters_/adhome/advertiser/pool',
    });
  };

  getShowColumns = () => {
    const columnWidthStr = localStorage.getItem(`ColumnWidth${window.pageProps.uid}`);
    let columnWidth = undefined;
    if (columnWidthStr) {
      columnWidth = JSON.parse(columnWidthStr);
    }
    this.columnMap = leadsCommonFuncAndConfig.getColumnsMap(this.state.customizedAttributes, this);
    this.columnMap.name = { name: 'name', customRender: this.renderLeadsId, title: '姓名', fixedable: true, adjustWidth: true,
      style: columnWidth && columnWidth.name ? { width: `${columnWidth.name}px` } : {} },
        this.columnMap.tel = { name: 'tel', customRender: this.renderTel, title: '电话', fixedable: true, adjustWidth: true,
          style: columnWidth && columnWidth.tel ? { width: `${columnWidth.tel}px` } : {} },
        this.columnMap.intentionScoreTagName = { name: 'intentionScoreTagName', customRender: this.renderIntentionScoreTagName, title: '线索评分', adjustWidth: true,
          style: columnWidth && columnWidth.intentionScoreTagName ? { width: `${columnWidth.intentionScoreTagName}px` } : {} },
        this.columnMap.leadsOpt = { name: 'leadsOpt', customRender: (type, name, value, data) => {
            return leadsCommonFuncAndConfig.renderLeadsOpt(
                type,
                name,
                value,
                data,
                this.state.tmcConfig,
                (e) => this.showDetail(e, data.leadsId, data.name, data.telLocation),
                (e) => this.showCallDialog(e, data.tel, data.leadsId, data.name, data.telLocation, data.tags)
            )
          }, title: '操作', fixedable: true, fixedAlign: 'right', adjustWidth: true, style: { width: '120px' } },
        this.showColumns = [];
    unmovableCells.forEach((value) => {
      this.showColumns.push(this.columnMap[value]);
    });
    this.state.selected.forEach((value) => {
      if (this.columnMap[value]) {
        this.showColumns.push(this.columnMap[value]);
      }
    });
    this.showColumns = this.showColumns.filter((item) => item.name !== 'leadsOpt');
    this.showColumns.push(this.columnMap.leadsOpt);
  };

  onBatchClaim = (e) => {
    if (this.state.claiming) return;
    const leadsIds = _.get(this, 'lvObj.current.selectKeys', []);
    if (leadsIds.length < 1) {
      alert('请选择需要认领的线索');
      return;
    }
    beaconInstance.onUserAction(
        'btn_click',
        { page: '线索公海池', name: '线索认领' },
    );
    this.setState({ claiming: true });
    const onSuccess = () => {
      message.success('线索认领成功');
      this.lvObj.current.loadList();
      this.lvObj.current.setSelectKeys([]);
      this.lvObj.current.setBatchShow(false);
    };
    const params = { leadsIds };
    RPCFactory.leadsManage.claim(params)
    .done(() => setTimeout(onSuccess, 1000))
    .fail((ret, msg, xh, data) => {
      // 组装弹窗消息 by fighting
      const obtainReasons = _.map(data?.errors, ({ errorType = '', leadsIds = [] }, index) => {
        if (_.has(leadsObtainErrorDict, Number(errorType))) {
          return {
            reason: `${index + 1}、${leadsObtainErrorDict[Number(errorType)]}`,
            leadsIds: Array.isArray(leadsIds) ? leadsIds.join(' ')
                : leadsIds
          }
        }
      });
      // 认领失败展示弹窗
      if (!_.isEmpty(data?.errors)) {
        this.setState({
          showReasonsDialog: true,
          obtainReasons
        })
      } else {
        alert(msg);
      }
    })
    .always(() => {
      this.setState({
        claiming: false,
        claimConfirming: false,
      });
    });
  };

  onBatchDistribute = (e) => {
    const canDistribute =
        window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_MANAGER' ||
        window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_CMANAGER' ||
        window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_ADOPERATOR' ||
        window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_DATA_ANALYST' ||
        window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_CEMPLOYEE_MANAGER';
    if (canDistribute) {
      this.setState({ showBatchDistribute: true });
    } else {
      window.alert('您无权限进行分配！');
    }
  };

  onBatchChangeScore = (e) => {
    if (
        window.pageProps.operatorRole != 'OPERATOR_ROLE_LEADS_OBSERVER' &&
        window.pageProps.operatorRole != 'OPERATOR_ROLE_LEADS_SUPER_OBSERVER'
    ) {
      this.leadsScoreDialog.show(e.target);
    } else {
      window.alert('您无权限进行评分！');
    }
  };
  onBatchChangeState = (e) => {
    if (
        window.pageProps.operatorRole != 'OPERATOR_ROLE_LEADS_OBSERVER' &&
        window.pageProps.operatorRole != 'OPERATOR_ROLE_LEADS_SUPER_OBSERVER'
    ) {
      this.followTagDialog.show(e.target);
    } else {
      window.alert('您无权限进行状态修改！');
    }
  };

  onBatchDownload = () => {
    this.downloadLeads(true);
  }

  getBatchConfig() {
    if (isLeadsRole('免登陆', '超级管理员', '管理员')) return {
      left: (
          <div className="toolbar-right-group">
            <Button onClick={this.onBatchDistribute} className="borderless">
              <i className="icon icon-batch"></i>线索分配
            </Button>
            <Button onClick={this.onBatchChangeScore} className="borderless">
              <i className="icon icon-batch"></i>线索评分
            </Button>
            <Button onClick={this.onBatchChangeState} className="borderless">
              <i className="icon icon-batch"></i>线索状态
            </Button>
            {ENABLE_BATCH_TAG_UPDATE && (
                <Button onClick={this.onBatchUpdateLabel.bind(this)} className="borderless">
                  <i className="icon icon-batch"></i>线索标签
                </Button>
            )}
            {this.canDownload && (
                <Button onClick={this.onBatchDownload} className="borderless">
                  <i className="icon icon-download"></i>
                  <span className="spaui-text">下载线索</span>
                </Button>
            )}
          </div>
      ),
    };
    const openClaimConfirm = () => {
      this.setState({ claimConfirming: true });
    };
    const cancleConfirm = () => {
      this.setState({ claimConfirming: false });
    };
    if (this.state.isService) return {
      left: (
          <div className="toolbar-right-group">
            <Button onClick={openClaimConfirm} className="borderless">
              <i className="icon icon-batch" />
              <span>线索认领</span>
            </Button>
            <Dialog
                type="normal"
                title="确定领取选中线索吗"
                className="spaui-dialog-confirm-normal"
                show={this.state.claimConfirming}
                style={{ width: 400 }}
                onClose={cancleConfirm}
                onCancel={cancleConfirm}
                onSubmit={this.onBatchClaim}
                footerStyle={{ textAlign: 'center' }}
            ></Dialog>
          </div>
      ),
    };
    return null;
  }

  lvOptions = ({ payloads, customFunctions }) => {
    this.getAllFilterConfig();
    this.getShowColumns();

    const canGoToTestList = this.state.isInFormalLeadsPage
        && isLeadsRole('免登陆', '管理员', '超级管理员');

    return {
      fetchConfig: {
        action: this.getList,
        $onRequest: (params) => {
          // 在这处理请求参数对象
          const obj = { ...params };
          delete obj.startActionDate;
          delete obj.page_size;
          delete obj.page;
          obj.pageIndex = params.page;
          obj.pageSize = params.page_size;
          if (params.startActionDate) {
            obj.startActionDate = params.startActionDate.start_time;
            obj.endActionDate = params.startActionDate.end_time;
          }
          obj.leadsQueryScope = 4;
          obj.hideRepeatRegisterLeads = this.state.hideRepeatRegisterLeads;
          if (!this.state.isInFormalLeadsPage) {
            obj.leadsTags = ['7'];
          }
          return obj;
        },
        $onResponse: (data) => {
          try {
            data.list.forEach((obj) => {
              obj.customizedAttributes.forEach((item) => {
                obj[item.name] = item.value;
              });
            });
          } catch (error) {
            console.error(error);
          }
          return data;
        },
        $onError: window.alert,
      },
      toolbarConfig: {
        left: (
            <div className="toolbar-left">
              <h4>数据信息</h4>
            </div>
        ),
        right: (
            <div className="toolbar-right-group">
              {canGoToTestList && !judgeIsFromTMC() && (
                  <Button onClick={this.goToTestList.bind(this)} className="borderless custom-btn">
                    <span className="spaui-text">查看测试线索</span>
                  </Button>
              )}

              {this.state.uploadBtnList.length > 0 && (
                  <DropMenuTrigger
                      dropMenu={
                        <DropMenu
                            data={[{
                              name: 'upload',
                              title: '',
                              list: this.state.uploadBtnList
                            }]}
                            value={this.state.uploadBtnValue}
                            onChange={this.uploadHandleChange}
                        />
                      }
                  >
                    <Button className="borderless">
                      <i className="icon icon-upload"></i>
                      <span>上传数据</span>
                      <OverlayTrigger trigger="hover" overlay={(
                          <PopOver>
                            点击上传数据按钮分别支持外部导入其他渠道线索、导入战败线索和上传线索状态
                          </PopOver>
                      )}>
                        <i className="icon icon-help" />
                      </OverlayTrigger>
                    </Button>
                  </DropMenuTrigger>
              )}

              {this.canDownload && this.state.downloadBtnList.length > 0 && (
                  <DropMenuTrigger
                      dropMenu={
                        <DropMenu
                            data={[{
                              name: 'download',
                              title: '',
                              list: this.state.downloadBtnList
                            }]}
                            value={this.state.downloadBtnValue}
                            onChange={this.downloadHandleChange}
                        />
                      }
                  >
                    <Button className="borderless btn-download">
                      <i className="icon icon-download"></i>
                      <span>下载数据</span>
                    </Button>
                  </DropMenuTrigger>
              )}

              <DropMenuTrigger
                  alignment="right"
                  dropMenu={
                    <DropMenu
                        LinkComponent={leadsCommonFuncAndConfig.LinkComponent}
                        LinkComponentProps={{
                          edit: (data, value) => {
                            this.showColumn(data, value);
                          },
                          delete: (data) => {
                            this.deleteColumn(data);
                          },
                        }}
                        data={this.state.customerColumnsData}
                        value={this.state.columnValue}
                        onChange={this.columnHandleChange}
                        className="with-checkmark with-item-action"
                        preContent={
                          <Fragment>
                            <div className="spaui-submenu-header">
                              <Button onClick={this.resetColums} className="borderless full-width">
                                <span className="spaui-text">默认列表</span>
                              </Button>
                            </div>
                            <h5 className="spaui-submenu-head">常用自定义列</h5>
                          </Fragment>
                        }
                        postContent={
                          <div className="spaui-submenu-footer">
                            <Button onClick={this.selfShowColumn} className="borderless full-width">
                              <span className="spaui-text">自定义</span>
                            </Button>
                          </div>
                        }
                    />
                  }
              >
                <Button className="borderless">
                  <i className="icon icon-columns"></i>自定义列
                </Button>
              </DropMenuTrigger>
            </div>
        ),
      },
      filterConfig: {
        resetable: false,
        controls: this.filterControls,
        customConfigure: this.customFilterConfigure,
        defaultValuesByKey: this.initQuery,
      },
      batchConfig: this.getBatchConfig(),
      tableConfig: {
        defaultPageSize: 10,
        pageSizeOptions: [10, 20, 50, 200, 500],
        select: this.state.isInFormalLeadsPage ? 'multiple' : null,
        onColumnWidthChange: leadsCommonFuncAndConfig.handleColumnWidthChange,
        optionalConfig: {
          type: 'optional',
          target: 'leadsId',
          multiple: true,
          canOptional: true,
          onOptionalChange: this.onTableOptionalChange,
        },
        columns: this.showColumns,
      },
    };
  };

  lvPayloads = () => ({});

  lvCustomFunctions = () => ({});
}

const ReduxLeadsManagePage = connect(mapStateToProps)(LeadsManagePage);
export default withXundaData(ReduxLeadsManagePage);
